var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "city-station-preview" }, [
        _c("div", { staticClass: "city-station-title" }, [_vm._v("城市站")]),
        _c(
          "div",
          { staticClass: "city-station-list" },
          [
            _vm._l(4, function (i) {
              return _c("div", { key: i, staticClass: "city-card" }, [
                _vm._m(0, true),
                _c("p", { staticClass: "city-card-name" }, [
                  _vm._v("城市" + _vm._s(i)),
                ]),
              ])
            }),
            _vm._m(1),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "city-card-img" }, [
      _c("span", { staticClass: "iconfont icon-tu" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "city-card city-card-more" }, [
      _c("div", { staticClass: "city-card-img more-icon" }, [
        _c("span", { staticClass: "iconfont icon-gengduo1" }),
      ]),
      _c("p", { staticClass: "city-card-name" }, [_vm._v("更多")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }